import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "info" }
const _hoisted_2 = { class: "info__hero" }
const _hoisted_3 = { class: "info__section" }
const _hoisted_4 = { class: "info__list" }
const _hoisted_5 = { class: "info__section" }
const _hoisted_6 = { class: "info__cards" }
const _hoisted_7 = { class: "info-card__when" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", null, [
        _createElementVNode("span", {
          class: "info__hero-icon",
          "aria-hidden": "true"
        }, [
          _createElementVNode("svg", {
            viewBox: "0 0 32 32",
            role: "presentation"
          }, [
            _createElementVNode("circle", {
              cx: "16",
              cy: "16",
              r: "12",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "1.8"
            }),
            _createElementVNode("path", {
              d: "M16 8v7l4 3",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "1.8",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            })
          ])
        ]),
        _createElementVNode("p", { class: "info__eyebrow" }, "Mealorder Leitfaden"),
        _createElementVNode("h1", null, "So funktioniert deine Bestellung"),
        _createElementVNode("p", null, " Wann kannst du bestellen, bis wann kannst du etwas ändern und welche Mails kommen wann? Hier steht alles Wichtige für dich kompakt zusammengefasst. ")
      ], -1)),
      _createVNode(_component_router_link, {
        class: "info__back",
        to: "/"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(" Zurück zum Speiseplan ", -1)
        ]))]),
        _: 1
      })
    ]),
    _createElementVNode("section", _hoisted_3, [
      _cache[8] || (_cache[8] = _createElementVNode("h2", null, [
        _createElementVNode("span", {
          class: "info__section-icon",
          "aria-hidden": "true"
        }, [
          _createElementVNode("svg", {
            viewBox: "0 0 24 24",
            role: "presentation"
          }, [
            _createElementVNode("rect", {
              x: "3",
              y: "5",
              width: "18",
              height: "16",
              rx: "3",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "1.6"
            }),
            _createElementVNode("path", {
              d: "M8 3v4M16 3v4M3 11h18",
              stroke: "currentColor",
              "stroke-width": "1.6",
              "stroke-linecap": "round"
            })
          ])
        ]),
        _createTextVNode(" Bestellfenster ")
      ], -1)),
      _createElementVNode("p", null, [
        _cache[2] || (_cache[2] = _createTextVNode(" Du kannst nur für freigeschaltete Wochentage bestellen (aktuell: ", -1)),
        _createElementVNode("strong", null, _toDisplayString(_ctx.allowedWeekdayLabel), 1),
        _cache[3] || (_cache[3] = _createTextVNode("). Spätestens am ", -1)),
        _createElementVNode("strong", null, "Vortag bis " + _toDisplayString(_ctx.deadlineTime), 1),
        _cache[4] || (_cache[4] = _createTextVNode(" müssen neue oder geänderte Bestellungen eingegangen sein. ", -1))
      ]),
      _createElementVNode("ul", _hoisted_4, [
        _cache[6] || (_cache[6] = _createElementVNode("li", null, [
          _createElementVNode("strong", null, "Freigabe:"),
          _createTextVNode(" Sobald der Speiseplan importiert ist, sind die oben genannten Tage für Bestellungen geöffnet. ")
        ], -1)),
        _createElementVNode("li", null, [
          _cache[5] || (_cache[5] = _createElementVNode("strong", null, "Letzte Bestellung:", -1)),
          _createTextVNode(" Bis zum Vortag " + _toDisplayString(_ctx.deadlineTime) + " kannst du bestellen, stornieren oder etwas ändern. Danach wird alles fest an die Küche übergeben. ", 1)
        ]),
        _cache[7] || (_cache[7] = _createElementVNode("li", null, [
          _createElementVNode("strong", null, "Wochengerichte:"),
          _createTextVNode(" Sobald ein wöchentliches Gericht hinterlegt ist, erscheint es automatisch. Gibt es keins, siehst du auf der Startseite direkt den Hinweis dazu. ")
        ], -1))
      ])
    ]),
    _createElementVNode("section", _hoisted_5, [
      _cache[10] || (_cache[10] = _createElementVNode("h2", null, [
        _createElementVNode("span", {
          class: "info__section-icon info__section-icon--mail",
          "aria-hidden": "true"
        }, [
          _createElementVNode("svg", {
            viewBox: "0 0 24 24",
            role: "presentation"
          }, [
            _createElementVNode("rect", {
              x: "3",
              y: "5",
              width: "18",
              height: "14",
              rx: "3",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "1.6"
            }),
            _createElementVNode("path", {
              d: "M4 7l8 6 8-6",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "1.6",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            })
          ])
        ]),
        _createTextVNode(" E-Mail Zeitplan ")
      ], -1)),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emailSchedule, (mail) => {
          return (_openBlock(), _createElementBlock("article", {
            key: mail.title,
            class: "info-card"
          }, [
            _cache[9] || (_cache[9] = _createElementVNode("span", {
              class: "info-card__icon",
              "aria-hidden": "true"
            }, [
              _createElementVNode("svg", {
                viewBox: "0 0 24 24",
                role: "presentation"
              }, [
                _createElementVNode("path", {
                  d: "M12 6v6l3 2",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "1.6",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }),
                _createElementVNode("circle", {
                  cx: "12",
                  cy: "12",
                  r: "9",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "1.6"
                })
              ])
            ], -1)),
            _createElementVNode("p", _hoisted_7, _toDisplayString(mail.when), 1),
            _createElementVNode("h3", null, _toDisplayString(mail.title), 1),
            _createElementVNode("p", null, _toDisplayString(mail.description), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}